import type { RegionalTeachersDto, TeacherEntry } from '../../regionalApi';

import AvailabilityCell from './AvailabilityCell';
import { DAY_HEADS } from './roster-shared';

export default function AvailabilityTable({
  teachers,
  availability,
}: {
  teachers: ReadonlyArray<TeacherEntry>;
  availability: RegionalTeachersDto['availability'];
}) {
  if (Object.keys(availability).length === 0) {
    return (
      <div style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>No availability data this week.</div>
    );
  }
  return (
    <table className="nb-tbl">
      <thead>
        <tr>
          <th>Teacher</th>
          {DAY_HEADS.map((d) => (
            <th key={d} style={{ textAlign: 'center', width: 28 }}>
              {d}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {teachers.map((t) => {
          const row = availability[t.userId];
          if (!row) return null;
          return (
            <tr key={t.userId}>
              <td>{t.name.split(' ')[0]}</td>
              {row.map((cell, i) => (
                <td key={`${t.userId}-${DAY_HEADS[i]}`} style={{ textAlign: 'center', padding: 4 }}>
                  <AvailabilityCell value={cell} />
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
